// extracted by mini-css-extract-plugin
export default {"node-label":"LiylKR5j6VVc7r9N9Uj7"};